/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ApplicationInputs */

const en_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application`)
};

const es_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación`)
};

const fr_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application`)
};

const de_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applikation`)
};

const ja_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリケーション`)
};

const zh_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用程序`)
};

const ar_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق`)
};

const id_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikasi`)
};

const it_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicazione`)
};

const ru_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приложение`)
};

const pt_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicativo`)
};

const ko_val_application = /** @type {(inputs: Val_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`애플리케이션`)
};

/**
* | output |
* | --- |
* | "Application" |
*
* @param {Val_ApplicationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_application = /** @type {((inputs?: Val_ApplicationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ApplicationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_application(inputs)
	if (locale === "es") return es_val_application(inputs)
	if (locale === "fr") return fr_val_application(inputs)
	if (locale === "de") return de_val_application(inputs)
	if (locale === "ja") return ja_val_application(inputs)
	if (locale === "zh") return zh_val_application(inputs)
	if (locale === "ar") return ar_val_application(inputs)
	if (locale === "id") return id_val_application(inputs)
	if (locale === "it") return it_val_application(inputs)
	if (locale === "ru") return ru_val_application(inputs)
	if (locale === "pt") return pt_val_application(inputs)
	return ko_val_application(inputs)
});